var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3"},[_c('h2',[_vm._v("Test")]),_c('CustomTreeView',{attrs:{"treeData":_vm.treeData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }